<template>
	<Tooltip :hide-content="allActionsCount === 0">
		<Button :loading="isLoading" variant="quaternary" size="s" @click="showAdvisedActions()"
			><div class="flex items-center">
				<div :class="`text-message-${getActionsColor(actions)}`">
					{{ allActionsCount }}
				</div>
				&nbsp;<I18n path="actions.cta" /></div
		></Button>

		<template #content>
			<div v-if="actions.unscheduledEvents.length > 0" class="text-message-error">
				<I18n :options="{ count: actions.unscheduledEvents.length }" path="actions.unscheduledEvents" />
			</div>

			<div v-if="actions.unplannedEvents.length > 0" class="text-message-warning">
				<I18n path="actions.unplannedEvents" :options="{ count: actions.unplannedEvents.length }" />
			</div>
		</template>
	</Tooltip>
</template>

<script setup lang="ts">
import { Button, I18n, Tooltip } from '@bluebrick/saas-ui'
import { storeToRefs } from 'pinia'
import { getActionsColor } from '@/common/utils'
import { useActionsStore } from '@/features/actions/useActionsStore'
import { useSidebarStore } from '@/features/sidePanel/useSidebarStore'

const { actions, isLoading, allActionsCount } = storeToRefs(useActionsStore())
const { showAdvisedActions } = useSidebarStore()
</script>
